import { VluxMarkup } from '../../utils/vlux-markup';
var OfferServiceItemAdditional = /*@__PURE__*/ (function () {
    function OfferServiceItemAdditional(data) {
        if (data.type) {
            this.type = data.type;
        }
        if (data.image) {
            this.image = data.image;
        }
    }
    return OfferServiceItemAdditional;
}());
export { OfferServiceItemAdditional };
var OfferServiceItemDescription = /*@__PURE__*/ (function () {
    function OfferServiceItemDescription(data) {
        if (data.id) {
            this.id = parseInt(data.id, 10);
        }
        if (data.label) {
            this.label = VluxMarkup([data.label], true);
        }
        if (data.overrideLabel) {
            this.label = data.overrideLabel;
        }
        if (data.backendId) {
            this.backendId = data.backendId;
        }
        if (data.additional) {
            this.additional = new OfferServiceItemAdditional(data.additional);
        }
    }
    return OfferServiceItemDescription;
}());
export { OfferServiceItemDescription };
var OfferServiceItem = /*@__PURE__*/ (function () {
    function OfferServiceItem(data) {
        if (data.id) {
            this.id = parseInt(data.id, 10);
        }
        this.prices = [];
    }
    OfferServiceItem.prototype.setDescription = function (description) {
        this.description = description;
    };
    OfferServiceItem.prototype.addPrice = function (price) {
        this.prices.push(price);
    };
    return OfferServiceItem;
}());
export { OfferServiceItem };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/offer/offer.service-item.ts
// module id = null
// module chunks = 